<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { required } from "vuelidate/lib/validators";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIcDegerGiris from "@/models/StrIcDegerGiris";
import moment from "moment";
import StrKontrolGirisKanit from "../../StrKurumsalPerformans/StrKontrolGirisKanit/AddEdit.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";
export default {
  mixins: [Api, Sabit, StrIcDegerGiris],
  page: {
    title: "Kalite Öz Değerlendirme Veri Giriş",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    formcombobox,
    StrKontrolGirisKanit,
    ckeditor: CKEditor.component,
    BirimSecimi,
  },
  data() {
    return {
      title: this.$t("StrIcDegerGiris.Title"),
      items: [
        {
          text: this.$t("StrIcDegerGiris.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrIcDegerGiris.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrIcDegerGiris.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      KullaniciBilgileri: null,
      AltKayitKontrol: false,
      FormData: {},
      FilitrelemePenceresi: false,
      TableData: [],
      TableDataAlt: [],
      DataUpdate: "",
      AddEdit: "",
      DonemAdi: "",
      DonemCombobox: [],
      BirimIdCombobox: [],
      AnaBaslikCombobox: [],
      AltBaslikCombobox: [],
      Raporgirisid: null,
      Kontrolgirisid: null,
      Userid:"",
      Filter: {
        Donem: null,
        BirimId: null,
        AnaBaslik:null,
        AltBaslik: null,
        Degerlendirmetur: 1
      },
      Degerlendirmeturleri:[
            {"Id":"1","Value":"Kalite Öz Değerlendirme"},
            {"Id":"2","Value":"Akran Değerlendirme"},
            {"Id":"3","Value":"Program Öz Değerlendirme"},
            {"id":"4","value":"İç Değerlendirme"}
  
          ],
      DegerlendirmeturleriCombobox: [],
      editorData: "",
      StrIcDegerGirisData: [],
      Icdegergirisid: "",
      editor: ClassicEditor,
      CkeditorModel: [],
    };
  },
  validations: {
    Filter: {
      Donem: { required },
      BirimId: { required },
      AnaBaslik: { required },
      AltBaslik: {},
      Degerlendirmetur: { required }
    },
  },
  methods: {
    Get() {
      this.KullaniciBilgileri = store.getters.["auth/UserRolles"]
      this.FormData = this.IcDegerGirisData;
    },
    FilterGet() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.CkeditorModel = []
        this.DonemAdi = this.DonemCombobox.filter((notification) =>
          notification.Id.includes(this.Filter.Donem)
        )[0].Value;
        let Filter =
          "&DonemId=" +
          this.Filter.Donem +
          "&BirimId=" +
          this.Filter.BirimId +
          "&DetayId=" +
          this.Filter.AnaBaslik;
        this.ActionsFilterGet({
          Service: "StrIcDegerGiris/GetVeriGirisFormu",
          Page: this.Page,
          Filter: Filter,
        }).then((res) => {

          this.TableData = []
          if (res.Data[0]) {
            this.TableData = res.Data[0];
            this.Page.PageDataSize = res.TotalCount;
        
          }

          this.StrIcDegerGirisGet();
        });
        this.FilitrelemePenceresi = false;
      }
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
    AltBaslikSecim() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Ustid=" + this.Filter.AnaBaslik;
      this.AltBaslikCombobox = [];
      this.ActionsFilterGet({
        Service: "StrIcDegerTablo",
        Page: Page,
        Filter: Filter,
      }).then((res) => {
        for (var i = 0; i < res.Data.length; i++) {
          this.AltBaslikCombobox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Tabloadi,
          });
        }
      });
    },
    PostUpdate(index, TabloUstId, TabloId) {
      let Kontrol = true;
      let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
        (notification) => notification.TabloId.includes(TabloUstId)
      )[0];
      if (KayitKontrol) {
        KayitKontrol = KayitKontrol.Tablolar.filter((notification) =>
          notification.TabloId.includes(TabloId)
        )[0];

        if (KayitKontrol) {
          if (KayitKontrol.Giris.Id == "00000000-0000-0000-0000-000000000000") {
            Kontrol = false;
          }
        } else {
          Kontrol = false;
        }
      } else {
        Kontrol = false;
      }

      if (Kontrol) {
        this.FormData = KayitKontrol.Giris;
        this.FormData.Deger = this.CkeditorModel[index].Deger;
        this.Update("StrIcDegerGiris", this.FormData).then((res) => {
          if (res) {
            this.StrIcDegerGirisGet();
            this.FilterGet();
          }
        });
      } else {
        this.FormData.Deger = this.CkeditorModel[index].Deger;
        this.FormData.Donemid = this.Filter.Donem;
        this.FormData.Birimid = this.Filter.BirimId;
        this.FormData.Detayid = TabloId;
        this.Post("StrIcDegerGiris", this.FormData).then((res) => {
          if (res) {
            this.StrIcDegerGirisGet();
            this.FilterGet();
          }
        });
      }
    },

    StrIcDegerGirisGet() {
      this.StrIcDegerGirisData = [];
      let Filter =
        "&Donemid=" + this.Filter.Donem + "&Birimid=" + this.Filter.BirimId;
      this.ActionsFilterGet({
        Service: "StrIcDegerGiris",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.StrIcDegerGirisData = res.Data;
      });
    },

    OnayHazir(TabloUstId, TabloId) {
      if (TabloUstId || TabloId) {
        let durum = true;
        if (this.StrIcDegerGirisData[0]) {
          let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
            (notification) => notification.TabloId.includes(TabloUstId)
          )[0];
          if (KayitKontrol) {
            let Tablo = KayitKontrol.Tablolar;
            for (var i = 0; i < Tablo.length; i++) {
              if (Tablo[i].Giris.Id == "00000000-0000-0000-0000-000000000000") {
                durum = false;
              }
            }
          }
          return durum;
        }
      }
    },
    OnayKontrol(TabloUstId, TabloId) {
      if (TabloUstId || TabloId) {
        let durum = true;
        if (this.StrIcDegerGirisData[0]) {
          let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
            (notification) => notification.TabloId.includes(TabloUstId)
          )[0];
          if (KayitKontrol) {
            let Tablo = KayitKontrol.Tablolar;
            for (var i = 0; i < Tablo.length; i++) {
              if (Tablo[i].Giris.Onay == null || Tablo[i].Giris.Onay == 0) {
                durum = false;
              }
            }
          }
        }
        return durum;
      }
    },
    StrIcDegerGirisOnay(TabloUstId, TabloId, Islem) {
      if (TabloUstId || TabloId) {
        let durum = true;
        let KayitKontrol = this.StrIcDegerGirisData[0].Tablolar.filter(
          (notification) => notification.TabloId.includes(TabloUstId)
        )[0];
        let Tablo = KayitKontrol.Tablolar;
        let Onay = 1;
        if (Islem != "Onayla") {
          Onay = 0;
        }
        for (var i = 0; i < Tablo.length; i++) {
          let FormData = {
            Id: Tablo[i].Giris.Id,
            Onay: Onay,
            Deger: Tablo[i].Giris.Deger,
            Birimid: Tablo[i].Giris.BirimId,
            Detayid: Tablo[i].Giris.DetayId,
            Donemid: Tablo[i].Giris.DonemId,
          };

          this.Update("StrIcDegerGiris", FormData);
          this.FilterGet();
        }
        return durum;
      }
    },
    OlgunlukSecim(FormData) { 
      if (FormData.Id == "00000000-0000-0000-0000-000000000000") {
        let FormDatanew = {
          "Deger": FormData.Deger,
          "Olgunluk": FormData.Olgunluk,
          "DonemId": FormData.DonemId,
          "BirimId": FormData.BirimId,
          "DetayId": FormData.DetayId
        }
        this.Post("StrIcDegerGiris", FormDatanew).then((res) => {
          if (res) {
            this.FilterGet();
          }
        })

      } else {
        this.Update("StrIcDegerGiris", FormData).then((res) => {
          if (res) {
            this.FilterGet();
          }
        })
      } 

    },
    DegerKayit(FormData) { 
      if (FormData.Id == "00000000-0000-0000-0000-000000000000") {
        let FormDatanew = {
          "Deger": FormData.Deger,
          "DonemId": FormData.DonemId,
          "BirimId": FormData.BirimId,
          "DetayId": FormData.DetayId
        }
        this.Post("StrIcDegerGiris", FormDatanew).then((res) => {
          if (res) {
            this.FilterGet();
          }
        })

      } else {
        this.Update("StrIcDegerGiris", FormData).then((res) => {
          if (res) {
            this.FilterGet();
          }
        })
      } 

    },
    DegerlendirmeTureGoreBaslik(){
      this.ActionsFilterGet({ Service: "StrIcDegerTablo", Page: this.Page, Filter: "&Seviye=0&Degerlendirmetur=" + this.Filter.Degerlendirmetur }).then(
      (res) => {
      const filteredData = res.Data.filter(item => item.Ustid === null);
      filteredData.sort((a, b) => a.Sirano - b.Sirano);
      this.AnaBaslikCombobox = filteredData.map(item => ({
        Id: item.Id,
        Value: item.Tabloadi
      }));
     }
    );
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({Service:"OKeyValues",Page:Page, Filter:"&Tip=1561&Kod=7" }).then(resp => {  

    this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: "&Approval=true&UstIdDoluMu=true&TipId=" + resp.Data[0].Id + "&VeriTipi=3" }).then((res) => {
      let Tarih = moment(new Date()).format("YYYY-MM-DD");
      for (var i = 0; i < res.Data.length; i++) {
        if (
          this.$options.filters.formatDate(res.Data[i].BaslamaTarihi) <=
          Tarih &&
          Tarih <=
          this.$options.filters.formatDate(res.Data[i].BitisTarihi)
        ) {
          this.DonemCombobox.push({
            Id: res.Data[i].Id,
            Value: res.Data[i].Aciklama,
          });
        }
      }
    });
    
  }); 
   this.Userid = store.getters.["auth/TokenUserId"] 
    
    let Filter = "&Kisaadi=STR";

    this.ActionsFilterGet({Service: "Ouygulama",  Page:Page,Filter:Filter}).then((res) => {
      if(res){


      this.ActionsFilterGet({ Service: "OUserBirimYetki", Page: Page, Filter: "&Userid=" + this.Userid + "&Uygulamaid=" + res.Data[0].Id}).then((resp) => {
      this.BirimIdCombobox = [];
      for (var i = 0; i < resp.Data.length; i++) {
              this.ActionsSingleGet({
                Service: "OBirim",
                Id: resp.Data[i].Birimid,
              }).then((response) => {
                        this.BirimIdCombobox.push({
                          Id: response.Data.Id,
                          Value: response.Data.BirimAdi,  });
              });
      }

      });
      }

    });
     

    this.DegerlendirmeTureGoreBaslik();
    
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">

                    <div class="row">


                      <div style="margin-top: -7px;" class="col-md-6">
                      <formcombobox :FormDataType="{
                        FieldName: 'Degerlendirmetur',
                        Field: 'combobox',
                        FieldTitle: $t('StrIcDegerGiris.Filtreleme.Degerlendirmetur'),
                        ComboDataArray: Degerlendirmeturleri,
                      }" :Value="Filter.Degerlendirmetur" :v="$v.Filter.Degerlendirmetur" @input="(Filter.Degerlendirmetur = $event),DegerlendirmeTureGoreBaslik()" />
                      </div>

                      <div style="margin-top: -7px;" class="col-md-6" v-if="Filter.Degerlendirmetur == 1">
                        <BirimSecimi  :title="$t('StrIcDegerGiris.Filtreleme.BirimId')" :sutun="'0'" :title_position="'mb-3'"
                          :selected="Filter.BirimId" :YetkiKontrol="1" :labels_lg="'3'" :multiple="false" :BirimTipId="null"
                          @Secilmis_Idler="Filter.BirimId = $event" />
                      </div>


                      <div  style="margin-top: -7px;" class="col-md-6" v-if="Filter.Degerlendirmetur != 1">
                        <formcombobox :FormDataType="{
                          FieldName: 'Birimler',
                          Field: 'combobox',
                          FieldTitle: $t('StrIcDegerGiris.Filtreleme.BirimId'),
                          ComboDataArray: BirimIdCombobox,
                        }" :Value="Filter.BirimId" :v="$v.Filter.BirimId" @input="Filter.BirimId = $event" />
                      </div>

                      <div style="margin-top: -7px;" class="col-md-6">
                      <formcombobox :FormDataType="{
                        FieldName: 'Donem',
                        Field: 'combobox',
                        FieldTitle: $t('StrIcDegerGiris.Filtreleme.Donem'),
                        ComboDataArray: DonemCombobox,
                      }" :Value="Filter.Donem" :v="$v.Filter.Donem" @input="Filter.Donem = $event" />
                      </div>

                      <div style="margin-top: -7px;" class="col-md-6">
                      <formcombobox :FormDataType="{
                        FieldName: 'AnaBaslik',
                        Field: 'combobox',
                        FieldTitle: $t('StrIcDegerGiris.Filtreleme.AnaBaslik'),
                        ComboDataArray: AnaBaslikCombobox,
                      }" :Value="Filter.AnaBaslik" :v="$v.Filter.AnaBaslik"
                        @input="(Filter.AnaBaslik = $event), AltBaslikSecim()" />
                      </div>


                    </div>
                    

                      <b-button @click="FilterGet()" class="btn btn-primary" variant="primary">{{
                      $t("StrIcDegerGiris.Filtreleme.Button")
                      }}</b-button>
                  </div>
              </div>

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">

                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer" v-if="0==1">
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("StrIcDegerGiris.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="TableData">
                <div class="table-responsive" v-for="(TableVerileri, Tabloindex) in TableData.Tablolar"
                  :key="Tabloindex">
                  <table class="table table-striped table-bordered mb-0" v-if="TableVerileri.Tablolar.length != 0">
                    <thead class="table-light">
                      <tr>
                        <th>{{ $t("StrIcDegerGiris.Table.TabloAdi") }}</th>
                        <th>{{ TableVerileri.TabloAdi }}</th>
                      </tr>

                    </thead>
                    <tbody>
                    
                      <tr>
                        <td colspan="3">
                          <table class="table table-striped table-bordered mb-0"  style="border: 2px solid #323748;">
                            <thead class="table-light" v-for="(Tablolar, index) in TableVerileri.Tablolar" :key="index">
                              <tr v-if="index == 0">
                                <th>
                                  {{ $t("StrIcDegerGiris.Table.Olcutler") }}
                                </th>
                                <th>
                                  {{ DonemAdi }}

                                  <br />
                                  <i class="mdi mdi-check-all me-1" @click="
                                    StrIcDegerGirisOnay(
                                      TableVerileri.TabloId,
                                      Tablolar.TabloId,
                                      'Onayla'
                                    )
                                  " v-if="
  OnayKontrol(
    TableVerileri.TabloId,
    Tablolar.TabloId
  ) == false &&
  OnayHazir(
    TableVerileri.TabloId,
    Tablolar.TabloId
  ) &&
  RolesControl(KullaniciBilgileri, 'StrKaliteOnay')
">
                                    {{ $t("StrIcDegerGiris.Table.Onayla") }}
                                  </i>
                                  <i class="mdi mdi-close me-1" @click="
                                    StrIcDegerGirisOnay(
                                      TableVerileri.TabloId,
                                      Tablolar.TabloId,
                                      'OnayIptal'
                                    )
                                  " v-else-if="
  OnayKontrol(
    TableVerileri.TabloId,
    Tablolar.TabloId
  ) &&
  OnayHazir(
    TableVerileri.TabloId,
    Tablolar.TabloId
  ) &&
  RolesControl(KullaniciBilgileri, 'StrKaliteOnay')
">
                                    {{ $t("StrIcDegerGiris.Table.OnayIptal") }}
                                  </i>
                                </th>
                                <th>{{ $t("StrIcDegerGiris.Table.Detay") }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(Tablolar, index) in TableVerileri.Tablolar" :key="index">
                                <th scope="row">{{ Tablolar.TabloAdi }}</th>
                                <td>

                                  <table class="table table-striped table-bordered mb-0">
                                    <thead class="table-light">
                                      <tr>
                                        <th colspan="5">{{ Tablolar.Aciklama }}</th> 
                                      </tr>
                                    </thead>
                                    <thead class="table-light"  v-if="!((TableVerileri.UstId == 'c25ff26b-245d-4f1e-b48d-9e07e50607ad') || (TableVerileri.UstId == 'ab263f6a-bc17-4580-8896-003ddc602603'))">
                                      <tr>
                                        <th>Olgunluk 1</th>
                                        <th>Olgunluk 2</th>
                                        <th>Olgunluk 3</th>
                                        <th>Olgunluk 4</th>
                                        <th>Olgunluk 5</th>
                                      </tr>
                                    </thead>
                                    <tbody v-if="!((TableVerileri.UstId == 'c25ff26b-245d-4f1e-b48d-9e07e50607ad') || (TableVerileri.UstId == 'ab263f6a-bc17-4580-8896-003ddc602603'))">
                                      <tr> 
                                      <td>
                                        <b-form-group>
                                          <b-form-radio class="mb-3" :value="Tablolar.Olgunluk1" plain v-model="Tablolar.Giris.Olgunluk"
                                            :name="'olgunluk' + Tablolar.Giris.DetayId"
                                           ></b-form-radio></b-form-group>
                                        {{ Tablolar.Olgunluk1 }}
                                      </td>
                                      <td>
                                        <b-form-group>
                                          <b-form-radio class="mb-3" :value="Tablolar.Olgunluk2" plain v-model="Tablolar.Giris.Olgunluk"
                                            :name="'olgunluk' + Tablolar.Giris.DetayId"
                                           ></b-form-radio></b-form-group>
                                        {{ Tablolar.Olgunluk2 }}
                                      </td>
                                      <td>
                                        <b-form-group>
                                          <b-form-radio class="mb-3" :value="Tablolar.Olgunluk3" plain v-model="Tablolar.Giris.Olgunluk"
                                            :name="'olgunluk' + Tablolar.Giris.DetayId"
                                           ></b-form-radio></b-form-group>
                                        {{ Tablolar.Olgunluk3 }}
                                      </td>
                                      <td>
                                        <b-form-group>
                                          <b-form-radio class="mb-3" :value="Tablolar.Olgunluk4" plain v-model="Tablolar.Giris.Olgunluk"
                                            :name="'olgunluk' + Tablolar.Giris.DetayId"
                                           ></b-form-radio></b-form-group>
                                        {{ Tablolar.Olgunluk4 }}
                                      </td>
                                      <td>
                                        <b-form-group>
                                          <b-form-radio class="mb-3" :value="Tablolar.Olgunluk5" plain v-model="Tablolar.Giris.Olgunluk"
                                            :name="'olgunluk' + Tablolar.Giris.DetayId"
                                             ></b-form-radio></b-form-group>
                                        {{ Tablolar.Olgunluk5 }}
                                      </td>
                                      </tr>
                                
                                    </tbody>
                                    <thead class="table-light">
                                      <tr>
                                        <th colspan="5">Değer</th> 
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                   <td colspan="5">
                                    
                          <ckeditor    v-model="Tablolar.Giris.Deger" :editor="editor" ></ckeditor>
                                   </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                </td>
                                <td>
                                  <i v-b-modal.StrKontrolGirisKanit @click="Icdegergirisid = Tablolar.Giris.Id"
                                    class="mdi mdi-clipboard-edit-outline me-1">
                                    {{ $t("StrIcDegerGiris.Table.Kanit") }}
                                  </i> <br>
                                  
                                  <button class="btn btn-primary" @click="OlgunlukSecim(Tablolar.Giris)">
                                    Değerlendirme Kaydet
        </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StrKontrolGirisKanit :Icdegergirisid="Icdegergirisid" :Raporgirisid="Raporgirisid"
        :Kontrolgirisid="Kontrolgirisid" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrIcDegerGiris.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrIcDegerGiris.Filtreleme.Content") }}
            <br><br>
            <div class="mb-3">


              <BirimSecimi :title="$t('StrIcDegerGiris.Filtreleme.BirimId')" :sutun="'0'" :title_position="'mb-3'"
                :selected="Filter.BirimId" :YetkiKontrol="1" :labels_lg="'3'" :multiple="false" :BirimTipId="null"
                @Secilmis_Idler="Filter.BirimId = $event" />


            </div>
            <div class="mb-3">
              <formcombobox :FormDataType="{
                FieldName: 'Donem',
                Field: 'combobox',
                FieldTitle: $t('StrIcDegerGiris.Filtreleme.Donem'),
                ComboDataArray: DonemCombobox,
              }" :Value="Filter.Donem" :v="$v.Filter.Donem" @input="Filter.Donem = $event" />
            </div>

            <div class="mb-3">
              <formcombobox :FormDataType="{
                FieldName: 'AnaBaslik',
                Field: 'combobox',
                FieldTitle: $t('StrIcDegerGiris.Filtreleme.AnaBaslik'),
                ComboDataArray: AnaBaslikCombobox,
              }" :Value="Filter.AnaBaslik" :v="$v.Filter.AnaBaslik"
                @input="(Filter.AnaBaslik = $event), AltBaslikSecim()" />
            </div>

            <b-button @click="FilterGet()" class="btn btn-primary" variant="primary">{{
              $t("StrIcDegerGiris.Filtreleme.Button")
            }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
